/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardText, CardBody, Table } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { colorArr, sortByOptions } from '../../helper';

const BasketAnalysisTable = ({ dataToShowForDatesSelected,
  title, filterBasedOnFilter, categorisedBasedOn, currentlyShow,
  viewReportButton }) => {
  const { t } = useTranslation('common');
  const categorisedBasedOnRef = useRef({ categorisedBasedOn });

  const [selectedOptions, setSelectedOptions] = useState([])
  const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
  const allCategories = {}
  const currentDataByCategory = {};
  const tableHeader = [];

 // console.log(month)

  useEffect(() => {
    if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
      setSelectedOptions([])
    }
  }, [categorisedBasedOn])

  const changeFilter = (value) => {
    setSelectedOptions(value)
  };

  const currentMonthCat = Object.keys(dataToShowForDatesSelected);
  
  let dataToPlot = [];
  const options = [];

  const reduceCallback = (acc, day) => {
    if (acc[day?.category]) {
      acc?.[day?.category]?.push(day)
    } else {
      acc[day?.category] = [day]
    }

    if (day && !allCategories[day?.[categorisedBasedOn]]) {
      if (!day?.[categorisedBasedOn] || day?.[categorisedBasedOn] === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.[categorisedBasedOn]] = day?.[categorisedBasedOn]
      }
    }
    return acc
  } 

  const getRepurchaseRate = (toralCus, repeatCus) => {
    let v = 0;
    if (repeatCus > 0) {
      v = (( repeatCus / toralCus) * 100).toFixed(2) || '0.00';
    }
    else {
      v = 0.00;
    }
    return v;
  }

  const getColorCode = (salesPer) => {
    let colorCode;

    if (salesPer < 0) {
      const negValue = salesPer.split('-');
      if (negValue[1] < 10) {
        colorCode = colorArr[0].toString();
      }
      else if (negValue[1] > 10 && negValue[1] < 20) {
        colorCode = colorArr[1].toString();
      }
      else if (negValue[1] > 20 && negValue[1] < 30) {
        colorCode = colorArr[2].toString();
      }
      else if (negValue[1] > 30 && negValue[1] < 40) {
        colorCode = colorArr[3].toString();
      }
      else if (negValue[1] > 40 && negValue[1] < 50) {
        colorCode = colorArr[4].toString();
      }
      else if (negValue[1] > 50 && negValue[1] < 60) {
        colorCode = colorArr[5].toString();
      }
      else if (negValue[1] > 60 && negValue[1] < 70) {
        colorCode = colorArr[6].toString();
      }
      else if (negValue[1] > 70 && negValue[1] < 80) {
        colorCode = colorArr[7].toString();
      }
      else if (negValue[1] > 80 && negValue[1] < 90) {
        colorCode = colorArr[8].toString();
      }
      else if (negValue[1] > 90) {
        colorCode = colorArr[9].toString();
      }
    }
    else if (salesPer > 0) {
      if (salesPer < 1) {
        colorCode = colorArr[10].toString();
      }
      else if (salesPer >= 1 && salesPer < 5) {
        colorCode = colorArr[11].toString();
      }
      else if (salesPer >= 5 && salesPer < 10) {
        colorCode = colorArr[12].toString();
      }
      else if (salesPer >= 10 && salesPer < 15) {
        colorCode = colorArr[13].toString();
      }
      else if (salesPer >= 15 && salesPer < 20) {
        colorCode = colorArr[14].toString();
      }
      else if (salesPer >= 20 && salesPer < 25) {
        colorCode = colorArr[15].toString();
      }
      else if (salesPer >= 25 && salesPer < 30) {
        colorCode = colorArr[16].toString();
      }
      else if (salesPer >= 30 && salesPer < 35) {
        colorCode = colorArr[17].toString();
      }
      else if (salesPer >= 35 && salesPer < 40) {
        colorCode = colorArr[18].toString();
      }
      else if (salesPer >= 40) {
        colorCode = colorArr[19].toString();
      }
    }
    else {
      colorCode = colorArr[20].toString();
    }
    return colorCode;
  }

    let TableHeader = [];
  
    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = dataToShowForDatesSelected?.[cat] ?? [];
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
        if(i === 0)
        {
          TableHeader = TableHeader.concat(Object.keys(currentYearMonthDayWise));
        }
        
        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, category) => {
         
          let reoccurPer;
        if(cat === category) {
          reoccurPer = 'self';
        }
        else {
          reoccurPer = currentYearMonthDayWise[category]?.[0]?.reOccurPerc;
        }
        const cardColorCode = getColorCode(reoccurPer);
        acc[category] = {
          percentage: reoccurPer,
          ColorCode: cardColorCode           
        };
        
        return acc
        }, {})
        options.push({
        value: cat, label: cat
        })
        dataToPlot.push({
        title: cat,
        categoryWiseAmountTotal,
        })

    }
  
  if (selectedOptions?.length) {
    const selected = selectedOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToPlot = dataToPlot.filter(item => selected[item.title])
  }

  const sortBy = sortBySelected?.value;
  if (sortBy === 'title') {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
  } else {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy] < b?.[sortBy] ? 1 : -1)
  }

  
  return (
    <Col xs="12">
      <Card className="pb-3 show-categ-daily-sales">
        <CardBody>
          <div className="card__title row align-items-center">
            <h5 className="bold-text col-md-3">{title}</h5>
            <div className="form__form-group mb-0 col-md-9" id='dvTable'>
              <div className="row justify-content-center align-items-center">
               <div className="col-11">
                  <span className="form__form-group-label font-weight-bold">
                    {`Select ${currentlyShow?.label}`}</span>
                  <div className="form__form-group-field">
                    <Select
                      value={selectedOptions}
                      options={options}
                      clearable={false}
                      placeholder={`Select ${currentlyShow?.label}`}
                      className="select_filter"
                      onChange={changeFilter}
                      classNamePrefix="react-select"
                      isMulti
                    />
                  </div>
                </div>               
                <div className="col-1">
                  <div className="form__form-group-field">
                  {viewReportButton?.()}
                  </div>
                </div>
              </div>
            </div>
            <Table responsive striped className="dashboard__table-orders" width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', minWidth: '150px' , fontSize: 9 }}>Category</th>
                  {TableHeader.sort((a, b) => a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).map((item, index) => (
                    <th style={{ textAlign: 'center', fontSize: 9 }}>{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataToPlot?.length ? dataToPlot?.map(dataValue => (
                  <tr>
                    <td style={{ paddingTop: '2px', paddingBottom: '2px', fontSize: 9 }}>{dataValue.title}
                    </td>
                    {TableHeader.sort((a, b) => a?.toLowerCase() > b?.toLowerCase() ? 1 : -1).map((item, index) => (
                      <td style={{
                        paddingTop: '2px', paddingBottom: '2px', paddingLeft: '3px',
                        paddingRight: '3px', marginLeft: '0px', marginRight: '0px',
                      }}>
                        {dataValue?.categoryWiseAmountTotal?.[item]?.percentage === 'self' && (
                        <Card body style={{
                          background: colorArr[20],
                           marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>                            
                        100 %
                          </CardText> 
                          </Card>
                        )}
                        {dataValue?.categoryWiseAmountTotal?.[item]?.percentage > 0 && (
                        <Card body style={{
                          background: dataValue?.categoryWiseAmountTotal?.[item]?.ColorCode,

                           marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>                            
                {setCurrencyFormat(Number(dataValue?.categoryWiseAmountTotal?.
                [item]?.percentage).toFixed(2), false)} %
                          </CardText>                          
                        </Card>
                        )}
                         {dataValue?.categoryWiseAmountTotal?.[item]?.percentage === '0.0' && (
                        <Card body style={{
                          background: '#f5f5f5',

                           marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>                            
                {setCurrencyFormat(Number(dataValue?.categoryWiseAmountTotal?.
                [item]?.percentage).toFixed(2), false)} %
                          </CardText>                          
                        </Card>
                        )}
                      </td>
                    ))}
                  </tr>
                )) : 'No data to display'}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

BasketAnalysisTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  // firstColumn: PropTypes.string,
 //  month: PropTypes.object.isRequired,
  title: PropTypes.string,
  filterBasedOnFilter: PropTypes.func.isRequired,
  categorisedBasedOn: PropTypes.string,
  currentlyShow: PropTypes.object.isRequired,
  viewReportButton: PropTypes.func.isRequired,
};

BasketAnalysisTable.defaultProps = {
  title: 'Basket Analysis',
  // firstColumn: 'Product Category',
  categorisedBasedOn: 'category',
}

export default BasketAnalysisTable;

